import { render } from "./SearchDropdownList.vue?vue&type=template&id=3b0bcaac&scoped=true&ts=true"
import script from "./SearchDropdownList.vue?vue&type=script&lang=ts"
export * from "./SearchDropdownList.vue?vue&type=script&lang=ts"

import "./SearchDropdownList.vue?vue&type=style&index=0&id=3b0bcaac&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0bcaac"]])

export default __exports__